import usersList from "./list";
import userDetails from "./details";

export default {usersList, userDetails};
